<template>
    <v-list-item class="my-2" @click="handleClick(true)">
        <v-list-item-content @mouseover="showCompanyName = true" @mouseleave="showCompanyName = false">
            <v-list-item-title class="kbDarkBlueText--text" v-html="app.app_name"></v-list-item-title>
            <v-expand-transition>
                <v-list-item-subtitle class="kbSemiLightGrayText--text" v-if="showCompanyName">{{ app.company.name }}</v-list-item-subtitle>
            </v-expand-transition>
        </v-list-item-content>
        <v-list-item-action class="text-caption" v-if="showManageButtons">
            <v-btn icon color="kbDarkBlueText" text @click.stop="viewApp(app.company, app)">
                <v-icon>settings</v-icon>
            </v-btn>
        </v-list-item-action>
    </v-list-item>
</template>

<script>
import userTypes from '@/libs/userTypes'
export default {
  data () {
    return {
      showCompanyName: false,
      userTypes
    }
  },
  methods: {
    handleClick (redirect) {
      if (this.showManageButtons) {
        this.search = ''
        this.show = false
        this.$store.dispatch('getCompany', this.app.company.UUID).then(res => {
          if (res) {
            this.$store.dispatch('getApp', { appId: this.app.UUID, getStatistics: false }).then(() => {
              if (redirect && this.$route.path !== '/home') {
                this.$router.push('/home')
              }
            })
          }
        })
      } else {
        this.$emit('input', this.app)
      }
      this.$emit('closeMenu')
    },
    viewApp () {
      this.$router.push(`/companies/${this.app.company.UUID}/apps/${this.app.UUID}`)
      this.handleClick(false)
    }
  },
  props: {
    app: {
      type: Object
    },
    showManageButtons: {
      type: Boolean,
      default: true
    }
  }
}
</script>
